<template>
  
  <el-dialog :visible.sync="dialogVisibleok"  title="放款确认" :close-on-click-modal="false" :close-on-press-escape="false">

    <el-form :model="dataForm"  ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '150px'">
      <div style="display: flex;align-items: center;">
        <h3 style="margin-right: 20px;">支付渠道</h3>
        <el-select v-model="dataForm.payMethodId" placeholder="请选择" disabled>
          <el-option
            v-for="(item,index) in channelList"
            :key="index"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <h3>债权转让方</h3>
      <div class="line-box">
      <el-form-item label="三方账户名" class="styW">
          <el-input v-model="dataForm.creditor.bankName" disabled ></el-input>
      </el-form-item>
      <!-- <el-form-item label="系统ID" class="styW">
          <el-input v-model="dataForm.creditor.oidUserno" disabled ></el-input>
      </el-form-item> -->
      <el-form-item label="三方合作银行账号" class="styW">
          <el-input v-model="dataForm.creditor.bankAccount" disabled ></el-input>
      </el-form-item>
          
      <el-form-item label="交易用途" class="styW">
          <el-input v-model="dataForm.creditor.loanUsage" disabled ></el-input>
      </el-form-item> 

      <el-form-item label="放款金额" class="styW">
          <el-input v-model="dataForm.creditor.loanAmount" disabled ></el-input>
      </el-form-item>
      <!-- <el-form-item label="手续费"  class="styW">
          <el-input v-model="dataForm.creditor.loanAmountFee" disabled ></el-input>
      </el-form-item> -->
     
      <!-- <el-form-item label="总金额" prop="amount" class="styW">
          <el-input v-model="dataForm.creditor.totalAmount" disabled ></el-input>
      </el-form-item> -->
      <el-form-item label="账户余额" prop="registerProvinceCode" class="styW">
          <el-input v-model="dataForm.creditor.amtBalcur" disabled ></el-input>
      </el-form-item>
      </div>
      <h3>原始债权人</h3>
      <div class="line-box"> 
      <el-form-item label="三方账户名" class="styW">
          <el-input v-model="dataForm.originalCreditor.username" disabled ></el-input>
      </el-form-item>
      <el-form-item label="三方合作银行账号" class="styW">
          <el-input v-model="dataForm.originalCreditor.bankAccount" disabled ></el-input>
      </el-form-item>
      <el-form-item label="放款金额" prop="registerProvinceCode" class="styW">
          <el-input v-model="dataForm.originalCreditor.totalAmount" disabled ></el-input>
      </el-form-item>
    </div>
      <h3 class="title-box">收款方  <span>7*24小时到账</span></h3>
     
      <div class="line-box"> 
      <el-form-item label="银行卡号/账号" class="styW">
          <el-input v-model="dataForm.payee.bankAccount" disabled ></el-input>
      </el-form-item>
      
      <el-form-item label="开户名" class="styW">
          <el-input v-model="dataForm.payee.accountName" disabled></el-input>
      </el-form-item>
    </div>
    <div v-if="dataForm.payee.payeeType == 'ENTERPRISE'">
      <el-form-item label="银行名称" class="styW">
          <el-input v-model="dataForm.payee.bankName" disabled></el-input>
      </el-form-item>
      <div class="line-box">
        <el-form-item label="开户行所在省" class="styW">
          <el-input v-model="dataForm.payee.bankProName" disabled></el-input>
        </el-form-item>
        <el-form-item label="所在市" class="styW">
          <el-input v-model="dataForm.payee.bankCityName" disabled></el-input>
        </el-form-item>
      </div>
      <el-form-item label="开户支行名称" class="styW">
          <el-input v-model="dataForm.payee.brabankName" disabled></el-input>
      </el-form-item>
    </div>
      <!-- <el-form-item label="合同和申请书" prop="bankCardNo">
        <div class="compact">
            <div @click="compact('shen')">借款申请书</div>
            <div @click="compact('he')">借款合同</div>
        </div>
      </el-form-item> -->
      </el-form>
    <template slot="footer">
      <el-button @click="loanCancel()">{{ $t('cancel') }}</el-button>
      <el-button :disabled="zf" v-loading="zf" type="primary" @click="loanIsOk()" >{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
export default {
  props: {
    applyId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      dialogVisibleok:false,
      date:'',
      gjr:false,
      zf:false,
      channelList:[],
      dataForm: {
        payMethodId:'0',
        "creditor": {
          "amtBalcur": '',
          "bankAccount": "",
          "bankName": "",
          "loanAmount": '',
          "loanAmountFee": '',
          "loanUsage": "",
          "oidUserno": "",
          "totalAmount": ''
        },
        "originalCreditor": {
          "bankAccount": "",
          "totalAmount": '',
          "username": ""
        },
        "payee": {
          "bankAccount": "",
          "bankName": "",
          "accountName": "",
          "bankProName":"",
          "bankCityName":"",
          "brabankName":""
        }
      }
    }
  },
  created(){
    
    
    this.$http.get(`/sys/dict/data/list?dataType=pay_channel`).then(r=>{
        this.channelList = r.data.data ? r.data.data.map(item => ({value:item.dictValue,label:item.dictLabel})) : []
    })
  },
  methods: {
    getLoanData(id){
      console.log(id)
     
      this.$http.get('/loan/tloanapply/toLoan/'+id).then(r=>{
        
        if(r.data.code == 0){
          this.dataForm = r.data.data
          this.dataForm.payMethodId = this.dataForm.payMethodId.toString()
          this.dialogVisibleok = true
        }else{
          this.$message({
            type:'error',
            message:r.data.msg,
            duration: 5000,
              
          })
        }
        console.log(r)
      })
      console.log(id)
    },
    openLoan(){

    },
    // 页面跳转
    compact(r){
      const routeUrl = this.$router.resolve({
          path: "/loanok",
        
          query: { id: 96 },
          });

      window.open(routeUrl.href, "_blank");
    },
    // 放款确认
    loanIsOk(){
      if(this.dataForm.payMethodId == 0){
        this.dialogVisibleok = false
        this.$emit('iscodeFS',this.dataForm.payMethodId)
      }else if(this.dataForm.payMethodId == 1){
        this.zf = true;
        this.$http
        .post("/api/trans/transfer", {
          applyId: this.applyId,
          password: 'ttf',
          postscript: "暂无说明",
          randomKey: 'ttf',
          payChannelId: this.dataForm.payMethodId
        })
        .then((r) => {
          this.zf = false;
          if(r.data.code == 500){
            this.$message({
              type: "error",
              message: r.data.msg,
            });
            return
          }
          this.dialogVisibleok = false
          this.$emit('signedFS')
        }).catch((e) => {
          this.zf = false;
        });
      }else{
        this.$message({
          type:'error',
          message:'请选择放款方式',
          duration: 5000,
            
        })
      }
      
    },
    // 取消
    loanCancel(){
      this.dialogVisibleok = false
      this.$emit('signedFS')
    },

  },
}
</script>

<style lang="scss" scoped>
 .tj{
  border: 1px solid #ccc;
 }
 .gjr{
  border: 1px solid red;
 }
 .ht{
  display: flex;
  justify-content: space-between;
 }
 .compact{
   display: flex;
   color: blue;
   justify-content: space-between;
 }
 .styW{
  width: 350px;
 }
 h3{
  margin: 20px 0;
 }
 .title-box{
  span{
    color: #2FB679;
    font-size: 14px;
    margin-left: 20px;
    font-weight: 0;
  }
 }
</style>
